import React, { useEffect, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { CButton } from '@coreui/react'

import '../../styles/file.css'

// Shows a file (pdf, tif)
// file (any valid format for Document Component): item to show
export default function File({ file }) {
    const [currentPage, changePage] = useState(1);
    const [numPages, setNumPages] = useState();
    const [loading, setLoading] = useState(true); // loading when first rendered
    const [scale, setScale] = useState(1);

    const pageControls = useRef();

    // Runs after loading pdf successfully
    function OnLoadSuccess(pdf) {
        setNumPages(pdf.numPages);
        setLoading(false);
    }

    function OnPageChange(value) {
        // If at min/max range already
        if ((currentPage === 1 && value < 0) || (currentPage === numPages && value > 0)) return;

        changePage(currentPage + value);
    }

    function zoomIn() {
        setScale(scale * 1.2); 
    }


    function zoomOut() {
        setScale(scale / 1.2); 
    }

    return (
        <Document file={file} onLoadSuccess={(pdf) => OnLoadSuccess(pdf)}>
            {currentPage == null ? null :
                <div id="pdf" onContextMenu={(e) => e.preventDefault()}>
                    <Page
                        pageNumber={currentPage}
                        scale={scale}
                        renderForms={false}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                    />
                </div>

            }
            {loading === true ? null :
                <page-controls ref={pageControls}>
                    <CButton
                        onClick={() => OnPageChange(-1)}
                        color='secondary'
                        variant='text'
                    >
                        {'<'}
                    </CButton>
                    <span> {currentPage} of {numPages} </span>
                    <CButton
                        onClick={() => OnPageChange(1)}
                        color='secondary'
                        variant='text'
                    >
                        {'>'}
                    </CButton>
                    <CButton onClick={zoomIn} color='secondary' variant='text'>{'+'}</CButton>
                    <CButton onClick={zoomOut} color='secondary' variant='text'>{'-'}</CButton>
                </page-controls>
            }
        </Document>
    );
}